import { sortBy, uniqBy } from 'lodash-es';

import type { ControlApplicabilityDto, OrganizationDto, ReportGroupsDto } from '@src/api';
import type { ControlApplicabilityDtoDefId } from '@stores/dictionaryStores/controlApplicabilityStore/controlApplicabilityStore';

type ControlApplicabilityWithChildren = ControlApplicabilityDto & {
  children?: ControlApplicabilityWithChildren[];
  key: string;
  title: string;
};

// Группировка по report_group (1 уровень иерархии), по report_type (2 уровень иерархии)
export const toTreeView = (
  controls: ControlApplicabilityDtoDefId[],
  reportGroups: ReportGroupsDto[],
  organizations: OrganizationDto[],
): ControlApplicabilityWithChildren[] => {
  const output = sortBy(
    controls.filter((control) => control.repGroupCode && control.orgCode),
    ['orgCode', 'repGroupCode', 'ctrlGroupOrder'],
  );

  return uniqBy(output, 'orgCode').map((item) => {
    const organizationName = organizations?.find((organization) => organization.code === item.orgCode)?.name;

    return {
      orgCode: item.orgCode,
      key: item.orgCode ?? '',
      title: `${item.orgCode} - ${organizationName}`,
      children: uniqBy(
        output.filter((el) => el.orgCode === item.orgCode),
        'repGroupCode',
      ).map((group) => {
        const groupName = reportGroups?.find((reportGroup) => reportGroup.code === group.repGroupCode)?.name;

        const uniqByCtrlGroupCode = uniqBy(
          output.filter((el) => el.orgCode === item.orgCode && el.repGroupCode === group.repGroupCode),
          'ctrlGroupCode',
        );

        return {
          repGroupCode: group.repGroupCode,
          orgCode: group.orgCode,
          key: `${group.orgCode} - ${group.repGroupCode}`,
          title: `${group.repGroupCode} - ${groupName}`,
          count: controls.filter(
            (control) => control.repGroupCode === group.repGroupCode && control.orgCode === group.orgCode,
          ).length,
          children: uniqByCtrlGroupCode.map((el) => ({
            orgCode: item.orgCode,
            repGroupCode: group.repGroupCode,
            ctrlGroupCode: el.ctrlGroupCode,
            key: `${el.orgCode} - ${el.repGroupCode} - ${el.ctrlGroupCode}`,
            title: `${el.ctrlGroupCode} - ${el.ctrlGroupName}`,
            count: controls.filter(
              (control) =>
                control.repGroupCode === el.repGroupCode &&
                control.orgCode === el.orgCode &&
                control.ctrlGroupCode === el.ctrlGroupCode,
            ).length,
          })),
        };
      }),
    };
  });
};
